import {
  Text,
  Banner,
  GreyGrey90,
  IconArrowUpRight,
  IndigoIndigo60,
  Primary13Regular,
  Flex,
  Link
} from '@sequencehq/core-components'

const AvalaraCategoriesConfigurationBanner = () => {
  return (
    <Banner
      data-testid="avalaraConfiguration.banner.info"
      variant="neutral"
      withIcon={false}
    >
      <Flex flexDirection="column" width="100%" gap={1}>
        <Text color={GreyGrey90} width="100%">
          Tax is calculated based on the category of each product. Add an
          Avalara tax code to each tax category to automatically calculate sales
          tax.
        </Text>
        <Flex width="100%">
          <Link.Unstyled to="/settings/tax-rates">
            <Flex alignItems="center" alignContent="center" gap={1}>
              <Text color={IndigoIndigo60}>Configure tax categories</Text>
              <IconArrowUpRight
                {...Primary13Regular}
                style={{
                  display: 'inline',
                  color: IndigoIndigo60
                }}
              />
            </Flex>
          </Link.Unstyled>
        </Flex>
      </Flex>
    </Banner>
  )
}

export default AvalaraCategoriesConfigurationBanner
